<template>
    <div>
        <card-header title="Activity" icon="fa-users-viewfinder"/>

        <card-toolbar class="pt-2">
            <b-switch size="is-small" class="mr-4 ml-2" v-model="events">User Events</b-switch>
            <b-switch size="is-small" class="mr-4 ml-2" v-model="system">System Events</b-switch>
            <b-switch size="is-small" class="mr-4" v-model="log">Logger</b-switch>
            <b-switch size="is-small" class="mr-4" v-model="errors">Errors</b-switch>
            <b-switch size="is-small" class="mr-4" v-model="traffic">API Traffic</b-switch>
        </card-toolbar>

        <card-body>
            <card-list>

                <template v-for="act in activity">
                    <activity-user :activity="act" v-if="events && act.type === 'user'"/>
                    <activity-traffic :activity="act" v-if="traffic && act.type === 'traffic'"/>
                    <activity-logger :activity="act" v-if="log && act.type === 'log'"/>
                </template>

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from "@/http_client";
    import ReviewTile from "../../components/tiles/ReviewTile";
    import async from "async";
    import CardListItem from "../../TIER/components/CardListItem";
    import Toolbar from "../../TIER/components/Toolbar";
    import ActivityTraffic from "./ActivityTraffic";
    import ActivityLogger from "./ActivityLogger";
    import ActivityUser from "./ActivityUser";
    import moment from "moment/moment";

    export default {
        components: {ActivityUser, ActivityLogger, ActivityTraffic, Toolbar, CardListItem, ReviewTile, CardToolbar, SeparatorListItem, CardHeader, CardBody, CardList},
        props: ['card', 'child'],
        data() {
            return {
                activity: [],
                events: true,
                system: true,
                traffic: false,
                log: false,
                errors: false
            };
        },
        methods: {
            load: function(force) {

            },
            reload: function() {
                this.load(true);
            }
        },
        mounted: function() {
            this.load();

            this.$options.sockets.onmessage = (data) => {
                let act = JSON.parse(data.data);
                this.activity.unshift(act);
            }
        },
        destroyed() {

        }
    };

</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
